<template>
  <div class="dlIndex">
    <el-collapse v-model="activeName">
      <el-collapse-item
        v-for="(item, index) in list"
        :key="index"
        :name="item.name"
      >
        <template slot="title">
          <div class="h_title">{{ item.name }}</div>
        </template>
        <div v-if="item.name == '予定'" class="cal_margin">
          <vab-calendar :type="'index'"></vab-calendar>
        </div>
        <div v-else>
          <div class="flex_colum">
            <div
              v-for="(s1, s1index) in item.children"
              :key="s1index"
              class="flex_start moude_item"
            >
              <div class="mark_box flex_center flex_center_align">
                {{ s1.name }}
              </div>
              <div class="line_2px"></div>
              <div class="flex_colum">
                <div
                  v-for="(s2, s2index) in s1.children"
                  :key="s2index"
                  class="nums_box flex_wrap"
                >
                  <div class="header_box flex_start">
                    <span class="title">{{ s2.name }}</span>
                    <span class="link">
                      すべて見る
                      <i class="el-icon-arrow-right el-icon--right"></i>
                    </span>
                  </div>
                  <div class="flex_start flex_wrap">
                    <div
                      v-for="(s3, s3index) in s2.children"
                      :key="s3index"
                      class="nums_item flex_space flex_center_align"
                      :class="s3.aniTemp ? 'ans' : 'ansleve'"
                      @mouseenter="mouChange('ent', s3)"
                      @mouseleave="mouChange('lev', s3)"
                    >
                      <span class="word">{{ s3.name }}</span>
                      <span class="num">
                        {{ s3.num }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
  export default {
    name: 'DlnIndex',
    data() {
      return {
        activeName: 'タスク一覧',
        list: [
          {
            name: 'タスク一覧',
            children: [
              {
                name: '日程調整',
                num: 10,
                children: [
                  {
                    name: '日程調整状況（事前調査）',
                    children: [
                      {
                        name: '未提出',
                        num: 10,
                        aniTemp: false,
                      },
                      {
                        name: '提出済み ',
                        num: 55,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 8,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 24,
                        aniTemp: false,
                      },
                      {
                        name: '再調整 ',
                        num: 99,
                        aniTemp: false,
                      },
                    ],
                  },
                  {
                    name: '日程調整状況（工事）',
                    children: [
                      {
                        name: '未提出',
                        num: 10,
                        aniTemp: false,
                      },
                      {
                        name: '提出済み ',
                        num: 55,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 8,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 24,
                        aniTemp: false,
                      },
                      {
                        name: '再調整 ',
                        num: 99,
                        aniTemp: false,
                      },
                    ],
                  },
                ],
              },
              {
                name: '作業可能日 ',
                num: 55,
                children: [
                  {
                    name: '回答状況',
                    children: [
                      {
                        name: '未提出',
                        num: 10,
                        aniTemp: false,
                      },
                      {
                        name: '提出済み ',
                        num: 55,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 8,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 24,
                        aniTemp: false,
                      },
                      {
                        name: '再調整 ',
                        num: 99,
                        aniTemp: false,
                      },
                    ],
                  },
                ],
              },
              {
                name: '書類確認 ',
                num: 8,
                children: [
                  {
                    name: '回答状況',
                    children: [
                      {
                        name: '未提出',
                        num: 10,
                        aniTemp: false,
                      },
                      {
                        name: '提出済み ',
                        num: 55,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 8,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 24,
                        aniTemp: false,
                      },
                      {
                        name: '再調整 ',
                        num: 99,
                        aniTemp: false,
                      },
                    ],
                  },
                ],
              },
              {
                name: '報告書確認 ',
                num: 24,
                children: [
                  {
                    name: '回答状況',
                    children: [
                      {
                        name: '未提出',
                        num: 10,
                        aniTemp: false,
                      },
                      {
                        name: '提出済み ',
                        num: 55,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 8,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 24,
                        aniTemp: false,
                      },
                      {
                        name: '再調整 ',
                        num: 99,
                        aniTemp: false,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            name: '予定',
            children: [
              {
                name: '日程調整',
                num: 10,
                children: [
                  {
                    name: '日程調整状況（事前調査）',
                    children: [
                      {
                        name: '未提出',
                        num: 10,
                        aniTemp: false,
                      },
                      {
                        name: '提出済み ',
                        num: 55,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 8,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 24,
                        aniTemp: false,
                      },
                      {
                        name: '再調整 ',
                        num: 99,
                        aniTemp: false,
                      },
                    ],
                  },
                  {
                    name: '日程調整状況（工事）',
                    children: [
                      {
                        name: '未提出',
                        num: 10,
                        aniTemp: false,
                      },
                      {
                        name: '提出済み ',
                        num: 55,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 8,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 24,
                        aniTemp: false,
                      },
                      {
                        name: '再調整 ',
                        num: 99,
                        aniTemp: false,
                      },
                    ],
                  },
                ],
              },
              {
                name: '作業可能日 ',
                num: 55,
                children: [
                  {
                    name: '回答状況',
                    children: [
                      {
                        name: '未提出',
                        num: 10,
                        aniTemp: false,
                      },
                      {
                        name: '提出済み ',
                        num: 55,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 8,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 24,
                        aniTemp: false,
                      },
                      {
                        name: '再調整 ',
                        num: 99,
                        aniTemp: false,
                      },
                    ],
                  },
                ],
              },
              {
                name: '書類確認 ',
                num: 8,
                children: [
                  {
                    name: '回答状況',
                    children: [
                      {
                        name: '未提出',
                        num: 10,
                        aniTemp: false,
                      },
                      {
                        name: '提出済み ',
                        num: 55,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 8,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 24,
                        aniTemp: false,
                      },
                      {
                        name: '再調整 ',
                        num: 99,
                        aniTemp: false,
                      },
                    ],
                  },
                ],
              },
              {
                name: '報告書確認 ',
                num: 24,
                children: [
                  {
                    name: '回答状況',
                    children: [
                      {
                        name: '未提出',
                        num: 10,
                        aniTemp: false,
                      },
                      {
                        name: '提出済み ',
                        num: 55,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 8,
                        aniTemp: false,
                      },
                      {
                        name: '催促中 ',
                        num: 24,
                        aniTemp: false,
                      },
                      {
                        name: '再調整 ',
                        num: 99,
                        aniTemp: false,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      }
    },
    methods: {
      mouChange(type, item) {
        if (type == 'ent') {
          item.aniTemp = true
        } else {
          item.aniTemp = false
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  @mixin animate {
    animation-duration: 0.2s;
    animation-direction: normal;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
  }
  .dlIndex {
    .h_title {
      font-weight: 500;
      font-size: 18px;
      color: #000000;
      height: 40px;
      padding-left: 12px;
      position: relative;
      &::before {
        content: '';
        width: 4px;
        height: 16px;
        background: #003350;
        position: absolute;
        left: 0;
        top: 60%;
        margin-top: -10px;
      }
    }
  }
  .dlIndex ::v-deep {
    .el-collapse-item__header {
      background: none !important;
      border: none !important;
    }
  }

  .dlIndex ::v-deep {
    .el-collapse-item__header .el-collapse-item__arrow {
      font-weight: 300;
      font-size: 15px;
      color: inherit;
    }
  }
  .dlIndex ::v-deep {
    .el-collapse-item__header:first-child {
      border-bottom: 1px solid #d1dae1 !important;
    }
  }
  .dlIndex ::v-deep {
    .el-collapse-item__wrap {
      background: none;
    }
  }
  .dlIndex ::v-deep {
    .el-collapse-item__content {
      line-height: inherit;
    }
  }
  .dlIndex {
    .moude_item {
      background: #ffffff;
      border-radius: 4px;
      box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.1);
      margin: 0 8px;
      margin-top: 12px;
      overflow: inherit;
      padding: 20px;
    }
    .mark_box {
      width: 110px;
      height: 36px;
      background: #003350;
      border-radius: 2px 18px 18px 2px;
      font-weight: 700;
      font-size: 15px;
      color: #ffffff;
      position: relative;
      left: -34px;
    }
    .nums_box {
      .header_box {
        margin-bottom: 8px;
        .title {
          font-weight: 400;
          font-size: 14px;
          color: #848484;
          display: block;
        }
        .link {
          font-weight: 400;
          font-size: 13px;
          text-decoration-line: underline;
          color: #004c82;
          margin-left: 16px;
        }
      }
      .nums_item {
        background: #ecf5ff;
        border-radius: 4px;
        width: 150px;
        height: 56px;
        position: relative;
        overflow: hidden;
        padding: 0 16px;
        cursor: pointer;
        margin-right: 8px;
        margin-bottom: 8px;
        &:hover {
          background: #71b4ff;
          .word {
            color: #fff;
          }
          .num {
            color: #fff;
            position: relative;
            &::before {
              content: '';
              width: 100%;
              height: 1px;
              background: #fff;
              position: absolute;
              left: 0;
              bottom: 0;
            }
          }
        }
        .word {
          font-weight: 600;
          font-size: 13px;
          color: #000000;
          display: block;
        }
        .num {
          font-weight: 700;
          font-size: 24px;
          color: #004c82;
          display: block;
          position: relative;
          z-index: 2;
        }
        .round {
          background: #ecf5ff;
          border-radius: 50%;
          width: 130px;
          height: 130px;
          position: absolute;
          right: -130px;
          top: 56px;
          z-index: 1;
        }
      }
    }
  }
  @keyframes ani {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
      background: #71b4ff;
    }
  }
  .cal_margin {
    margin-top: 12px;
    background: #fff;
  }
</style>
